export const PUBLIC_STATS_SNAPSHOT = {
    captured_at: "2026-10-23T20:06:28.594Z",
    stats: {
        data_brokers: 1438,
        data_broker_types: {
            people_search: 453,
            people_search_affiliate: 155,
            list_brokers: 184,
            advertising_marketing: 315,
            background_check: 31,
            data_enrichment: 210,
            job_recruiting: 20,
            healthcare_insurance: 33,
            surveillance_tech: 12,
            geolocation: 12,
            work_income_verification: 13,
        },
        custom_sites: 185093,
    },
};
